export const LIST_TYPES = {
	bullet: 'bullet',
	number: 'number',
}
